import { render } from "./Index.vue?vue&type=template&id=d2f5cafc"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseReqs/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2f5cafc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2f5cafc', __exports__)) {
    console.log('reload')
    api.reload('d2f5cafc', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=d2f5cafc", () => {
    console.log('re-render')
    api.rerender('d2f5cafc', render)
  })

}


export default __exports__